import { Row } from "@tanstack/react-table";

import { Button } from "@/components/ui/button/button";

import { RepaymentSchedule } from "./schema";
import { useEditRepaymentSchedule } from "../../../../../admin/other-loans/[loanId]/_components/edit-repayment-schedule-modal/use-edit-repayment-schedule";
import { Pencil } from "lucide-react";
// import { useTakeActionModal } from "../take-action-modal/use-action-modal";

interface DataTableRowActionsProps<TData> {
  row: Row<TData>;
}

export function DataTableRowActions<TData>({
  row,
}: DataTableRowActionsProps<TData>) {
  const originData = row.original as RepaymentSchedule;

  const { onOpenChange, setRs } = useEditRepaymentSchedule();

  return (
    <div className="flex items-center gap-4">
      <Button
        size="icon"
        className="w-6 h-6"
        onClick={() => {
          onOpenChange(true);
          setRs({
            id: originData?.id,
            date: originData?.dueDate,
          });
        }}
      >
        <Pencil className="w-3 h-3" />
      </Button>
    </div>
  );
}
